import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { environment } from 'src/environments/environment';
import { LoginService, UserData, UserInfo } from '../login/login.service';

export interface Dashboard_Response{
  data : Dashboard_Counter_Props[] | Dashboard_News_Props[] | undefined,
  error?: any,
  msg: string,
  success: boolean
}

export interface Dashboard_Counter_Props{
  panel_style: string
  title: string
  data: Dashboard_Counter[]
}

export interface Dashboard_Counter{
  title: string,
  value: number
}

export interface Dashboard_News_Props{
  panel_style: string
  title: string
  data: Dashboard_News[]
}

export interface Dashboard_News{
  title: string
}

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private invoiceUrl : string =  environment.url;
  //private invoiceUrl: string = AppConfig.settings.apiServer.url;

  private userInfo: UserInfo | undefined;
  private userData: UserData | undefined;

  constructor(private http: HttpClient, private router: Router, private loginService: LoginService) {}



  async getDashboard(){
    this.userData = JSON.parse(localStorage.getItem("einvuser") || "");
    return await this.getData(this.invoiceUrl + '/api/v1/users/' + this.userData!.user_id + "/dashboard");
  }

  async getDashboardNews(){
    this.userInfo = JSON.parse(localStorage.getItem("einvuser") || "");
    return await this.getData(this.invoiceUrl + '/api/v1/users/' + this.userInfo!.dms_user_id + "/dashboardNews");
  }

  /**
   * Metodo GET generico
   * @param url 
   * @returns 
   */
   private async getData(url : string) : Promise<Dashboard_Response> {
    let response = await this.http.get<any>(url).toPromise().then((data : any) => {
      return data;
    }).catch(() => {
      this.router.navigate(['../Login']);
    });
    return response;
  }

}
